export const locale = {
  lang: 'en',
  data: {
    'Tabs': {
      'Offer': 'Offer',
      'BasicDetail': 'Basic Detail',
      'File': 'File',
      'Category': 'Category',
      'WorkItem': 'Work Item'
    },
    'MESSAGE': {
      'Failed': 'Operation failed , try later',
      'Success': 'Success.',
      'CommingSoon': 'Comming Soon..',
      'Deleted': 'Deleted successfully',
    },
    'FIELDS': {
      'GoTo': 'See offer',
      'SRNO': 'Sr No',
      'Price': 'M2 total',
      'QTY': 'QTY',
      'Total': 'Price in total',
      'Text': 'Text',
      "ShowMaterials": "Offer draft",
      'TotalExclVAT': 'Total excl. VAT',
      'VAT': 'VAT',
      'TotalInclVAT': 'Total incl. VAT',
      'Distance': 'Distance',
      'TravelingTime': 'Time',
      'DistancePerDay': 'Distance per day',
      'PerDay': 'Pr. Day',
      'TotalTime': 'Total time',
      'Driving': 'DRIVING',
      'DrivingAmt': 'Driving',
      'NumberOfDrivingDays': 'No. of driving days',
      'NumberOfHours': 'Number of hours',
      'NumberOfDays': 'Number of days',
      'Timer-Min': 'Timer / Min',
      'DiscountByPostNumber': 'Discount by PostNumber',
      'CustomDrivingAmount': 'Custom Driving Amount',
      'TravelTimeReport': 'Travel time',
      'PaintTimeReport': 'Paint time',
      'TotalTimeReport': 'Total time',
    },
    'BUTTONS': {
      'AddCategory': 'Add Category',
      'PDFOREMAIL': 'PDF / Email',
      'GoToOffer': 'Goto offer',
      'SaveOffer': 'Save offer'
    },
    'Headers': {
      'DeleteCategory': 'Do you want to delete category',
    },
    'TOOTIPORTITLE': {
      'Edit': 'Edit',
      'Delete': 'Delete',
      'Copy': 'Kopi',
      //'AddOfferToCart':'Add Offer In Cart',
      'AddOfferToCart': 'Add To Cart',
      'ResetCategory': 'Reset Category Selection',
      'GoToParentCategory': 'Go To Parent Category',
      'GoToBackCategory': 'Go To Back Category',
      'ShowDirection': 'Show Direction',
      'CreateOrSaveOffer': 'Create/Save Offer',
      'Reset': 'Reset',
    }
  }
};
